// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2o4LW","right":"styles_right__18Us5"};